import config from "@/config"
import http from "@/utils/request"

export default {
  merchantApply: {
    url: `${config.API_URL}/merchantApply`,
    name: "商户进件单",
    get: async function (data = {}) {
      return await http.post(`${this.url}/wx/applyment/list`, data) //商户进件单列表
    }
  },
  wxMerchantApply: {
    url: `${config.API_URL}/merchantApply`,
    // url: `${config.API_URL}/token`, //测试
    name: "微信商户进件单",
    get: async function (data = {}) {
      return await http.post(`${this.url}/wx/applyment/list`, data) //商户进件单列表
    },
    detail: async function (data = {}) {
      return await http.post(`${this.url}/wx/applyment/detail`, data) //商户进件单详情
    },
    refreshWxMerchantApply: async function (data = {}) {
      return await http.post(`${this.url}/wx/applyment/refreshWxApplyStatus`, data) //刷新微信进件信息
    }
  }
}
